function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_298",
  "data-name": "Path 298",
  d: "M15.621,4.708V20.285a.724.724,0,0,1-.426.642.779.779,0,0,1-.314.066.708.708,0,0,1-.458-.168L9.6,16.745H6.738A1.745,1.745,0,0,1,5,14.975V10.019a1.745,1.745,0,0,1,1.738-1.77H9.6l4.827-4.08a.726.726,0,0,1,1.19.54Zm1.156,5.385a.708.708,0,0,0-.317.95,3.611,3.611,0,0,1,0,2.907.708.708,0,0,0,1.267.633,5.031,5.031,0,0,0,0-4.174.709.709,0,0,0-.95-.317ZM19.7,8.286a.708.708,0,0,0-1.267.633,8.749,8.749,0,0,1,0,7.155.708.708,0,0,0,1.267.633A10.149,10.149,0,0,0,19.7,8.286Z",
  transform: "translate(-5 -4.001)",
  fill: "#fff"
});

var SvgAudioMedia = function SvgAudioMedia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.615,
    height: 16.993,
    viewBox: "0 0 15.615 16.993",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudioMedia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio-media.f8b51510.svg";
export { ForwardRef as ReactComponent };